import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";
// import UserGemsService from "./user.gems.service";
export default class PrintQueService extends ApiService {
  template = "defaultTemplate";
  DOMAIN = DOMAIN.PRINT_QUE;
  icon = "PrintQue";
  Width = 500;
  singular = this.terminology.file.singular;
  plural = this.terminology.file.plural;
  vowel = this.terminology.file.vowel;

  gemItems = [
    {
      key: "listing",
      label: "All Estimates",
      icon: PrimeIcons.FILE,
      services: DOMAIN.ESTIMATE,
    },

    {
      key: "listing",
      label: "All Work Orders",
      icon: PrimeIcons.BRIEFCASE,
      services: DOMAIN.WORK_ORDER,
    },

    {
      key: "listing",
      label: "All Invoices",
      icon: PrimeIcons.FILE,
      services: 35,
    },
    {
      key: "listing",
      label: "All Payments",
      icon: PrimeIcons.FILE,
      services: DOMAIN.FUND_RECEIVED,
    },
    {
      key: "listing",
      label: "All Sales Receipts",
      icon: PrimeIcons.FILE,
      services: DOMAIN.SALES_RECEIPTS,
    },
    {
      key: "listing",
      label: "All Credit Memos",
      icon: PrimeIcons.FILE,
      services: DOMAIN.CREDIT_MEMO,
    },
    {
      key: "listing",
      label: "All Deposits",
      icon: PrimeIcons.HOME,
      services: DOMAIN.DEPOSIT,
    },
  ];

  constructor() {
    super("files");
  }
}
